// NOTE: DO NOT UPDATE THIS RESERVED TRANSLATION KEYS AND THEIR VALUES
const reservedTranslationsWithUniqueKeyNames = {
  leadingSpaceNotAllowed: 'Leading space not allowed.',
  trailingSpaceNotAllowed: 'Trailing space not allowed.',
  mustbeAtleastCharacters: '{{label}} must be atleast {{minNumber}} characters',
  cannotExceedCharacters: '{{label}} cannot exceed {{maxNumber}} characters',
  numberMustbeAtleast: '{{label}} must be atleast value {{minNumber}}',
  numberCannotExceed: '{{label}} cannot exceed {{maxNumber}}',
  isRequired: '{{label}} is required',
  emptySpaceNotContain: 'This field cannot contain space',
  404: '404',
  register: 'Register',
  login: 'Login',
  comingSoon: 'Coming Soon',
  submit: 'Submit',
  email: 'Email',
  termsConditions: 'Terms & Conditions',
  password: 'Password',
  eighteenPlus: 'I’m over 18 years of age and I agree to the Terms of Service',
  signUp: 'SignUp',
  createNewAccount: 'Create New Account',
  fullName: 'Full Name',
  referralCode: 'Referral Code',
  confirmPassword: 'Confirm Password',
  facebook: ' Facebook',
  google: 'Google',
  haveAnAccount: 'Have an account? ',
  pageNotFound: 'We can’t find the page you are looking for!',
  error: 'Error',
  somethingWentWrong: 'Something went wrong!',
  personalDetails: 'Personal Details',
  firstName: 'First Name',
  lastName: 'Last Name',
  dateOfBirth: 'Date of birth',
  phoneNumber: 'Phone Number',
  change: 'Change',
  saveChanges: 'Save Change',
  currentPassword: 'Current Password',
  newPassword: 'New Password',
  myProfile: 'My Profile',
  transactions: 'Transactions',
  deposit: 'Deposit',
  withdraw: 'Withdraw',
  referral: 'Referral',
  changePassword: 'Change Password',
  logout: 'Logout',
  currency: 'Currency.',
  view: 'View',
  ok: 'Ok',
  cancel: 'Cancel',
  userName: 'Username',
  passwordRegexMatch: 'Password must contain one uppercase, one number and one special case character',
  invalidEmailFormat: 'Invalid email format',
  noRecordsFound: 'No Records Found',
  backToLobby: 'Back to lobby',
  placeBet: 'Place Bet',
  rOICalculator: 'ROI Calculator',
  activeBets: 'ACTIVE BETS',
  closedBets: 'CLOSED BETS',
  publicBets: 'PUBLIC BETS',
  leaderboard: 'LEADERBOARD',
  howToplay: 'How to Play',
  bustPriceLabel: 'Bust Price',
  multiplierLabel: 'MULTIPLIER',
  pnLFee: 'PnL Fee',
  flatFee: 'Flat Fee',
  takeProfitLabel: 'TAKE PROFIT AT PRICE',
  closeBetLabel: 'CLOSE BET AT PRICE',
  priceUpLabel: 'WILL THE PRICE GO UP OR DOWN?',
  payoutMul: 'PAYOUT MULTIPLIER',
  allCurrencies: 'All Currencies',
  monthLabel: 'Month',
  day: 'Day',
  week: 'Week',
  betLabel: 'Bet Label',
  entryPrice: 'Entry Price',
  closeBetErr: 'Enter valid close bet amount',
  mulValErr: 'Multiplier value between 100 - 1000',
  profitErr: 'Enter valid take profit amount'

}

// NOTE: PLEASE ADD YOUR API SUCCESS MESSAGE TRANSLATIONS HERE ONLY
const apiSuccessMessagesTranslations = {
  loginSuccessfully: 'Login successfully.',
  logoutSuccessfully: 'Logout successfully.',
  passwordUpdateSuccessfully: 'Password updated successfully.',
  updatePlayerStatusSuccessfully: 'Player status updated successfully.',
  resetPasswordSuccessfully: 'Password reset successfully.',
  signupSuccessfully: 'Signup successfully.',
  betPlacedSuccessfully: 'Bet Placed  successfully.',
  betCancelledSuccessfully: 'Bet cancelled  successfully.'
}

// NOTE: PLEASE ADD YOUR API ERROR MESSAGE TRANSLATIONS HERE ONLY
const apiErrorMessagesTranslations = {
  UnAuthorized: 'Your session has timed out',
  LoginFailedError: 'Login Failed',
  InvalidCredentialsError: 'Invalid Credentials',
  InvalidTokenError: ' Token is not valid',
  InvalidSessionError: ' Session expired',
  CreateUserError: 'User cannot be created',
  DataMismatchError: 'Data does not match',
  UserNotFoundError: 'User not found',
  DuplicateEmailError: 'Email already exists',
  RequestInputValidationError: 'Please check the request data',
  ResponseInputValidationError: 'Response validation failed please refer to the JSON schema of the response',
  SocketRequestInputValidationError: 'Please check the request data for socket communication',
  SocketResponseValidationError: 'Response validation of socket communication failed, please refer to the JSON schema of the response',
  InternalServerError: 'Internal Server Error',
  InvalidSocketArgumentError: 'Please provide proper arguments: eventName, [payloadObject], and [callback]',
  InvalidCredentials: 'Credentials do not match',
  InvalidToken: 'Either access token was not passed or it has expired',
  InvalidSession: 'User session is not valid, please re-login',
  InvalidAccess: 'Permission denied',
  NonOperationalError: 'An error occurred on the server',
  UserNotExists: 'User does not exist',
  InvalidAction: 'Invalid action',
  SessionAlreadyStarted: 'Session already started',
  SessionNotStarted: 'Session not started',
  EmailNotVerified: 'Email not verified',
  InvalidGameTypeError: 'No settings found for the provided game type',
  InvalidGameRoundError: 'No game found for the provided game details',
  NoRoundRunningError: 'No round is running at the moment',
  NoPlacedBetFoundError: 'No placed bet found',
  NoWalletFoundError: 'Wallet not found with the specified data',
  NotEnoughBalanceError: 'Balance is not sufficient to perform the process',
  AutoRateIsInvalidError: 'Auto Rate is not within the valid limit',
  BetAmountIsNotInLimitError: 'Bet Amount is not within the valid limits',
  EmailNotFound: 'Email not found',
  UserNotAbove18YearsError: 'User is not above 18 years old',
  InvalidBlockchainAddress: 'Invalid Blockchain Address',
  AddressMismatch: 'Given Address and Recovered Address Mismatch',
  NonceLifetimeExpired: 'Nonce Lifetime Expired',
  SomethingWentWrong: 'Something Went Wrong',
  AccountNotActive: 'Account is not active',
  LoginTokenRequire: 'OTP (One-Time Password) is required',
  UserAlreadyExists: 'User already exists',
  InvalidVerificationToken: 'Invalid verification token',
  UserNotActive: 'User is blocked, please contact admin',
  FileUploadFailed: 'Image upload failed',
  EmailAlreadyVerified: 'Email is already verified',
  InvalidReferralCode: 'Invalid Referral Code',
  InvalidAffiliateCode: 'Invalid Affiliate Code',
  RecordNotFound: 'Record Not Found',
  WithdrawalRequestAlreadyPending: 'Withdrawal request is already pending',
  WalletDoesNotBelongToUser: 'Wallet does not belong to this user',
  BetAlreadyInProgress: 'Bet is already in progress',
  ServerSeedNotFoundErrorType: 'Server seed not found, please log in again',
  InvalidTileErrorType: 'Tile must be in the range of 1 to 25',
  FavoriteGameExistsErrorType: 'Favorite Game already exists',
  FavoriteGameNotFoundErrorType: 'Favorite Game not found',
  TransactionAlreadyPendingErrorType: 'Transaction is already pending',
  UserHasNoActiveBonusErrorType: 'User has no active bonus',
  BonusExpiredErrorType: 'Bonus has expired',
  UserHasAlreadyActivatedBonusWageringErrorType: 'User has already activated bonus wagering',
  InvalidRoundHashErrorType: 'Wrong Round Hash',
  InvalidSignatureErrorType: 'Wrong Signature',
  UserHasNoBonusAmountToClaimErrorType: 'User has no bonus amount to claim',
  BonusNotExistsErrorType: 'Bonus not found'
}

// NOTE: PLEASE ADD YOUR OTHER KEY TRANSLATIONS HERE ONLY
const otherTranslationKeys = {
  betAmount: 'Bet Amount',
  betHistory: 'Bet History',
  provablyFair: 'Provably Fair',
  minimumBet: 'Minimum bet',
  maximumBet: 'Maximum bet',
  selectYourBetAmount: 'Select your bet amount',
  buyInAmount: 'BuyIn Amount',
  selectYourBuyInAmountFromGivenRange: 'Select your BuyIn Amount from given range',
  profitOnWin: 'Profit on Win',
  noOfBets: 'Number of bets',
  auto: 'Auto',
  half: '½',
  double: '2X',
  start: 'Start',
  cancel: 'Cancel',
  prediction: 'Prediction',
  luckyNumber: 'Lucky Number',
  multiplier: 'Multiplier',
  chanceToWin: 'Chance to win',
  betBtn: 'Place Bet',
  bets: 'Bets',
  depositBtn: 'Deposit',
  rollOver: 'Roll Over',
  rollUnder: 'Roll Under',
  invalidBetAmount: 'Invalid bet amount',
  maxBetAmountLimit: 'Max bet amount {{value}} limit exceeded',
  minBetAmountLimit: 'Min bet amount is {{value}}.',
  noBalance: 'Bet amount is greater than wallet balance',
  noAutoCashout: 'Auto rate is required.',
  autoRateLimitWarning: 'Auto rate should be greater than {{value}}'
}

// NOTE: PLEASE ADD YOUR PREDICTION MARKET TRANSLATIONS HERE ONLY
const predictionMarketTranslations = {
  error: 'Error',
  somethingWentWrongPleaseTryAgain: 'Something went wrong. Please try again.',
  market: 'Market',
  limit: 'Limit',
  buy: 'Buy',
  sell: 'Sell',
  yes: 'Yes',
  no: 'No',
  up: 'Up',
  down: 'Down',
  yesCents: 'Yes {{cents}}¢',
  noCents: 'No {{cents}}¢',
  split: 'Split',
  merge: 'Merge',
  amount: 'Amount',
  shares: 'Shares',
  cancel: 'Cancel',
  submit: 'Submit',
  refresh: 'Refresh',
  loading: 'Loading',
  loadMore: 'Load More',
  gotIt: 'Got it',
  next: 'Next',
  previous: 'Previous',
  trade: 'Trade',
  portfolio: 'Portfolio',
  rules: 'Rules',
  volume: 'Volume',
  category: 'Category',
  notAvailable: 'N/A',
  open: 'Open',
  closed: 'Closed',
  removed: 'Removed',
  resolved: 'Resolved',
  cancelled: 'Cancelled',
  settled: 'Settled',
  ask: 'Ask',
  bid: 'Bid',
  asks: 'Asks',
  bids: 'Bids',
  total: 'Total',
  outcome: 'Outcome',
  options: 'Options',
  history: 'History',
  positions: 'Positions',
  orders: 'Orders',
  activity: 'Activity',
  comments: 'Comments',
  delete: 'Delete',
  reply: 'Reply',
  postComment: 'Post Comment',
  likeCount: 'Like ({{count}})',
  limitPrice: 'Limit price',
  postOnly: 'Post-only',
  youPay: 'You pay',
  shareCost: 'Share cost',
  toWin: 'To Win',
  youWillReceive: 'You\'ll receive',
  averagePrice: 'Average price',
  payable: 'Payable',
  processingFee: 'Processing fee',
  processingFees: 'Processing fees',
  estProcessingFee: 'Est. processing fee',
  estProcessingFeeIncluded: 'Est. processing fee (included)',
  processingFeeRefundable: 'Processing fee (refundable)',
  showMore: 'show more...',
  feePerShareIfItFillsNow: 'Fee per share if it fills now',
  marketSettled: 'Market settled',
  resultDeclared: 'Result declared',
  tradingClosedForThisOption: 'Trading is closed for this option.',
  waitingForNextMarket: 'No live market yet. Trading opens when the next window starts.',
  cryptoLiveNavLabel: 'Live Crypto',
  goBack: 'Go back',
  yourPosition: 'Your position',
  availableToTrade: 'Available to trade',
  locked: 'Locked',
  profitLoss: 'P/L',
  yesShares: 'Yes shares',
  outcomeShares: '{{outcome}} shares',
  avgOutcomePrice: 'Avg {{outcome}} Price',
  noShares: 'No shares',
  avgYesPrice: 'Avg Yes Price',
  avgNoPrice: 'Avg No Price',
  payoutProfitLoss: 'Payout P/L',
  outcomeWon: '{{outcome}} won',
  buyOutcome: 'Buy {{outcome}}',
  sellOutcome: 'Sell {{outcome}}',
  decreaseAmount: 'Decrease amount',
  increaseAmount: 'Increase amount',
  decreaseShares: 'Decrease shares',
  increaseShares: 'Increase shares',
  decreaseLimitPrice: 'Decrease limit price',
  increaseLimitPrice: 'Increase limit price',
  nobodySellingRightNow: 'Nobody is selling right now. Try a limit order so yours can wait.',
  nobodyBuyingRightNow: 'Nobody is buying right now. Try a limit order so yours can wait.',
  tooMuchMaxBuy: 'Too much. Max you can buy now is {{amount}}$.',
  tooManySharesMaxSell: 'Too many shares. Max you can sell now is {{amount}}.',
  restAsMakerOnly: 'Rest as maker only; rejected if it would take liquidity',
  mergeMatchedSharesIntoCollateral: 'Merge matched Yes and No shares back into collateral.',
  sharesPerSide: 'Shares (per side)',
  splitCollateralIntoShares: 'Split collateral into Yes and No shares for this market.',
  closeTradePanel: 'Close trade panel',
  openTradePanel: 'Open trade panel',
  orderSummary: 'Order summary',
  youSell: 'You sell',
  youMerge: 'You merge',
  estProceedsAtMarket: 'Est. proceeds at market',
  splitCollateral: 'Split collateral',
  mergeShares: 'Merge shares',
  splitHasNoProcessingFee: 'Split has no processing fee.',
  mergeHasNoProcessingFee: 'Merge has no processing fee.',
  includedInWhatYouPay: 'Included in what you pay. Applies when your order matches available offers.',
  deductedFromWhatYouReceive: 'Deducted from what you receive when your order matches available bids.',
  heldWithYourOrder: 'Held with your order. Refunded if it waits on the book. Kept only if it fills right away.',
  onlyIfOrderFillsRightAway: 'Only if your order fills right away — deducted from proceeds. No fee if it waits on the book.',
  makerFeeRebateExplanation: 'If someone else takes your waiting order, you can earn {{rebatePercent}}% of their fee.',
  postOnlyOrderExplanation: 'Post-only: this order only waits. If it would fill right away, it is cancelled and you get your money back.',
  notEnoughMoneyInWallet: 'Not enough money in your wallet.',
  notEnoughYesAndNoSharesToMerge: 'Not enough Yes and No shares to merge.',
  notEnoughSharesToSell: 'You do not have that many shares to sell.',
  maxOrderSizeIs: 'Max order size is {{amount}}.',
  orderCrossesOwnSellOrder: 'Order would cross your own sell order on this outcome. Cancel or lower that sell first.',
  orderCrossesOwnOppositeBuy: 'Order would cross your own opposite-side buy (Yes+No >= 100¢). Cancel or adjust that order first.',
  orderCrossesOwnBuyOrder: 'Order would cross your own buy order on this outcome. Cancel or raise that buy first.',
  placedBuyLimitOrder: 'Placed buy limit order of {{shares}} shares at {{price}} price',
  placedSellLimitOrder: 'Placed sell limit order of {{shares}} shares at {{price}} price',
  placedBuyMarketOrder: 'Placed buy market order of {{amount}} amount',
  placedSellMarketOrder: 'Placed sell market order of {{shares}} shares',
  mergedYesAndNoShares: 'Merged {{quantity}} yes and no shares into {{amount}} amount',
  splitAmountIntoYesAndNoShares: 'Splitted {{amount}} amount into {{yesShares}} yes shares and {{noShares}} no shares',
  closedBuyLimitOrder: 'Closed buy limit order of {{remainingShares}} shares at {{price}} price, total {{shares}}',
  closedSellLimitOrder: 'Closed sell limit order of {{remainingShares}} shares at {{price}} price, total {{shares}}',
  closedBuyMarketOrder: 'Closed buy market order of {{remainingAmount}} amount, total {{amount}}',
  closedSellMarketOrder: 'Closed sell market order of {{remainingShares}} shares, total {{shares}}',
  boughtSharesFromSeller: 'Bought {{quantity}} shares at {{price}} price from {{sellerName}}',
  soldSharesToBuyer: 'Sold {{quantity}} shares at {{price}} price to {{buyerName}}',
  marketResolvedWithOutcome: 'Market resolved with {{outcome}} outcome. Payout: ${{payout}} ({{winningShares}} winning shares).',
  buyerReceivedSharesSystemMinted: '{{buyerName}} received {{quantity}} shares at {{price}} (system minted)',
  buyerBoughtSharesFromSeller: '{{buyerName}} bought {{quantity}} shares at {{price}} from {{sellerName}}',
  sellerSoldSharesToSystem: '{{sellerName}} sold {{quantity}} shares at {{price}} to SYSTEM',
  sellerSoldSharesToBuyer: '{{sellerName}} sold {{quantity}} shares at {{price}} to {{buyerName}}',
  notifications: 'Notifications',
  unreadNotifications: '{{count}} unread notifications',
  recentCount: '{{count}} recent',
  loadingNotifications: 'Loading notifications...',
  noNotificationsYet: 'No notifications yet. You will be notified when orders are matched, completed, or markets resolve.',
  activityUpdate: 'Activity update',
  marketResolved: 'Market resolved',
  marketQuestionResolved: 'Market "{{questionTitle}}" has been resolved.',
  walletUpdated: 'Wallet updated',
  justNow: 'Just now',
  pickAMarket: 'Pick a market',
  pickAMarketDescription: 'Open any market and choose Yes or No based on your prediction. Then use the order panel to get shares.',
  preferLimitOrders: 'Prefer Limit orders',
  preferLimitOrdersDescription: 'Start here. Set the exact price (¢) and number of shares you want. Your order rests on the book until someone matches it — so you control the price.',
  noFillUseSplit: 'No fill? Use Split',
  noFillUseSplitDescription: 'If there isn\'t enough liquidity to fill a Limit order, Split your collateral into equal Yes and No shares. You can then sell the side you don\'t want.',
  needSpeedMarketOrders: 'Need speed? Market orders',
  needSpeedMarketOrdersDescription: 'Market orders fill instantly against the current order book. Use them when you want shares now and are okay paying the live market price.',
  holdOrCashOut: 'Hold or cash out',
  holdOrCashOutDescription: 'Sell anytime before resolution, or hold until the market settles. Winning shares pay $1 each; losing shares settle at $0.',
  restsOnTheBookUntilMatched: 'Rests on the book until matched',
  convertCashIntoYesAndNoShares: 'Convert cash into Yes + No shares',
  estShares: 'Est. shares',
  fillsInstantlyAtBookPrices: 'Fills instantly at book prices',
  resolvedYes: 'Resolved · Yes',
  payoutCredited: 'Payout credited',
  closeHowItWorks: 'Close how it works',
  tryItOut: 'Try It Out?',
  willThereBeAUsRecessionThisYear: 'Will there be a US recession this year?',
  exitTutorialAndReturnToMarkets: 'Exit tutorial and return to markets',
  exitDemo: 'Exit demo',
  howItWorks: 'How it works',
  demoGuide: 'Guide',
  demoGuideReopen: 'Reopen demo guide',
  demoGuideSkip: 'Skip guide',
  demoGuideFinish: 'Finish',
  demoGuideStepOf: 'Step {{current}} of {{total}}',
  demoGuideBack: 'Back',
  demoGuideWelcomeTitle: 'Welcome to the playground',
  demoGuideWelcomeBody: 'This is a safe demo market with play money. I will point at each piece of the UI and explain what it does — try the action if you like, or tap Next anytime.',
  demoGuideWelcomeHint: 'You start with $1000 demo balance. Nothing here is real.',
  demoGuideLimitTitle: 'Prefer Limit orders',
  demoGuideLimitBody: 'A Limit order lets you set the exact price (¢) and number of shares. It rests on the book until someone matches it — so you control the price instead of taking whatever is live.',
  demoGuideLimitHint: 'I opened Limit and suggested Buy Yes at 45¢ × 10. Submit if you want to try it, or Next to keep reading.',
  demoGuideOrderbookTitle: 'Your order on the book',
  demoGuideOrderbookBody: 'The orderbook shows resting bids and asks. When you place a limit order, it appears here (often marked You) until it fills or you cancel it.',
  demoGuideOrderbookHint: 'If you have no resting order yet, I place a small demo bid so you can see how it looks.',
  demoGuidePostOnlyTitle: 'Post-only (maker only)',
  demoGuidePostOnlyBody: 'Post-only means your limit buy only rests as a maker. If the price would fill immediately against an ask, the order is rejected and your money comes back — useful when you never want to take liquidity.',
  demoGuidePostOnlyHint: 'Post-only is checked with a non-crossing 45¢ bid ready. Try submit, or Next to continue.',
  demoGuideCancelTitle: 'Cancel a resting order',
  demoGuideCancelBody: 'Changed your mind? Open orders live under My Position. Cancelling unlocks cash reserved on buys (or shares locked on sells) so you can reuse them.',
  demoGuideCancelHint: 'Use Cancel on a row here if you want to practice — I keep a resting bid available for you.',
  demoGuideMarketTitle: 'Need speed? Market orders',
  demoGuideMarketBody: 'Market orders fill instantly against the current book. Use them when you want shares now and are okay paying live ask prices instead of waiting on your own limit.',
  demoGuideMarketHint: 'I set a $5 Buy on Market. Submit to see an instant fill, or Next to move on.',
  demoGuideMintTitle: 'No asks? Mint still works',
  demoGuideMintBody: 'If nobody is selling, you can still get shares. The engine can mint Yes+No from collateral by matching your buy against an opposite-side bid — so empty asks do not always mean “stuck.”',
  demoGuideMintHint: 'I cleared asks on this option. A $5 Market buy is ready — watch shares appear even with an empty ask side.',
  demoGuideSplitTitle: 'No fill? Use Split',
  demoGuideSplitBody: 'Split turns collateral into equal Yes and No shares instantly — no counterparty needed. Handy when the book is thin and you want inventory so you can sell the side you do not want later.',
  demoGuideSplitHint: 'I suggested splitting $10. Try it to see both Yes and No rise, or Next to continue.',
  demoGuideMergeTitle: 'Merge back to cash',
  demoGuideMergeBody: 'Merge is the reverse of Split: burn equal Yes and No shares to get collateral back. Useful when you hold both sides and want to flatten into cash.',
  demoGuideMergeHint: 'I suggested merging 5 per side. You need matching available Yes and No — Split first if needed.',
  demoGuideResolveTitle: 'Close and settle',
  demoGuideResolveBody: 'When trading ends, the market closes and then settles. Winning shares pay $1 each; losing shares settle at $0. In demo, Manage market lets you simulate close → pick a winner → settle.',
  demoGuideResolveHint: 'Open the panel if it is not open. Close first, then pick Yes/No and Settle for the selected option.',
  demoGuideDoneTitle: 'You have the basics',
  demoGuideDoneBody: 'Limit for price control, post-only to stay maker-only, cancel to free reserved funds, market for speed, mint when asks are empty, split/merge for inventory, and manage market for resolution.',
  demoGuideDoneHint: 'Replay anytime from the Guide button. Demo money resets when you re-enter demo mode.',
  demoGuideWaitingForAction: 'Finish the highlighted action to continue.',
  demoGuideDoThisFirst: 'Do this first',
  ganamosPolyTrade: 'Ganamos PolyTrade',
  trending: 'Trending',
  new: 'New',
  buyYes: 'Buy Yes',
  breaking: 'Breaking',
  noBreakingMarketsRightNow: 'No breaking markets right now.',
  backToMarkets: 'Back to markets',
  markets: 'Markets',
  openFullMarket: 'Open full market',
  tradeMarket: 'Trade market',
  previousMarket: 'Previous market',
  nextMarket: 'Next market',
  breakingMarkets: 'Breaking markets',
  showBreakingMarket: 'Show breaking market {{index}}',
  featuredMarkets: 'Featured markets',
  topMovers: 'Top Movers',
  viewAll: 'View all',
  liveTrades: 'Live Trades',
  live: 'Live',
  featuredMarket: 'Featured Market',
  untitledMarket: 'Untitled market',
  traders: 'Traders',
  endsIn: 'Ends in',
  tradeNow: 'Trade Now',
  showFeaturedMarket: 'Show featured market {{index}}',
  openNewsHeadline: 'Open news: {{headline}}',
  openNewsStatus: 'Open news: {{statusText}}',
  news: 'News',
  minimizeNews: 'Minimize news',
  expandNews: 'Expand news',
  closeNews: 'Close news',
  liveWire: 'Live wire',
  categoryNews: '{{category}} news',
  categoryDesk: '{{category}} desk',
  topHeadlinesAndRelatedCoverage: 'Top headlines and related coverage for this market category',
  topHeadlinesCount: 'Top {{count}} headlines',
  moreRelevantNews: 'More relevant news',
  noNewsStoriesForThisCategoryYet: 'No news stories for this category yet.',
  pullingHeadlinesFromTheWire: 'Pulling headlines from the wire…',
  scanningWire: 'Scanning wire…',
  categoryWaitingForStories: '{{category}} · waiting for stories',
  categoryStoriesCount: '{{category}} · {{count}} stories',
  searchMarkets: 'Search markets...',
  searchPortfolioActivity: 'Search portfolio activity',
  refreshPortfolioActivity: 'Refresh portfolio activity',
  portfolioSections: 'Portfolio sections',
  noPositionsFound: 'No positions found',
  yourOwnedPositionsWillAppearHere: 'Your owned positions will appear here.',
  noOrdersFound: 'No orders found',
  marketOrdersWillAppearInThisSection: 'Market orders will appear in this section.',
  limitOrdersWillAppearInThisSection: 'Limit orders will appear in this section.',
  noActivityYet: 'No activity yet',
  completedTradesAndSettlementsWillBeListedHere: 'Completed trades and settlements will be listed here.',
  cancelThisOrder: 'Cancel this order?',
  cancelThisOrderDescription: 'This will remove your open limit order from the book. You can place a new one anytime.',
  keepOrder: 'Keep order',
  cancelOrder: 'Cancel order',
  yourTradingDesk: 'Your trading desk',
  stateFilters: 'State filters',
  tablePagination: 'Table pagination',
  pagination: 'Pagination',
  previousPage: 'Previous page',
  nextPage: 'Next page',
  noDataAvailable: 'No data available',
  dataWillAppearHere: 'Data will appear here',
  thumbnail: 'Thumbnail',
  actions: 'Actions',
  rowThumbnail: 'Row thumbnail',
  yourPerformance: 'Your Performance',
  walletBalance: 'Wallet Balance',
  totalProfitIncludingTakerFee: 'Total Profit Including Taker Fee',
  totalProfit: 'Total Profit',
  hideTakerFee: 'Hide taker fee',
  showTakerFee: 'Show taker fee',
  profitOverTime: 'Profit Over Time',
  noChartDataAvailable: 'No chart data available',
  profitHistoryWillAppearAsTradesArePlaced: 'Profit history will appear as trades are placed.',
  profitChartTimeRange: 'Profit chart time range',
  userActivity: 'User activity',
  userActivityTitle: 'User Activity',
  userActivityTabs: 'User activity tabs',
  refreshUserActivity: 'Refresh user activity',
  addYourComment: 'Add your comment',
  shareYourThoughtsAboutThisMarket: 'Share your thoughts about this market...',
  anonymous: 'anonymous',
  hideReplies: 'Hide Replies',
  showReplies: 'Show Replies',
  writeAReply: 'Write a reply...',
  loadingEllipsis: 'Loading...',
  recentMarketBuysAndSellsWillAppearHere: 'Recent market buys and sells will appear here.',
  topHolders: 'Top Holders',
  topPositions: 'Top Positions',
  noTopPositionsFound: 'No top positions found',
  topPositionsWillAppearHereWithHighestRealizedPnl: 'The top positions will appear here with the highest realized PNL',
  yesHolders: 'Yes Holders',
  noHolders: 'No Holders',
  noTopHoldersFoundForYesOutcome: 'No top holders found for Yes outcome',
  topHoldersWillAppearHereForYesOutcome: 'The top holders will appear here for Yes outcome',
  noTopHoldersFoundForNoOutcome: 'No top holders found for No outcome',
  topHoldersWillAppearHereForNoOutcome: 'The top holders will appear here for No outcome',
  optionDetailsTabs: 'Option details tabs',
  orderbookOutcome: 'Orderbook outcome',
  orderbook: 'Orderbook',
  graph: 'Graph',
  myPosition: 'My Position',
  yesBook: 'Yes book',
  noBook: 'No book',
  spread: 'Spread',
  you: 'You',
  noAsks: 'No asks',
  noBids: 'No bids',
  loadingPosition: 'Loading position...',
  yourOrders: 'Your orders',
  marketOrdersForThisOptionWillAppearHere: 'Market orders for this option will appear here.',
  limitOrdersForThisOptionWillAppearHere: 'Limit orders for this option will appear here.',
  rulesAndMarketContext: 'Rules and market context',
  marketResolvesBasedOnListedCriteriaAndFinalOutcomeData: 'Market resolves based on listed criteria and final outcome data.',
  matchingEngineSettlesOpenOrdersUsingMarketResolutionRules: 'Matching engine settles open orders using market resolution rules.',
  ambiguousOutcomesAreHandledByPlatformAdjudicationPolicy: 'Ambiguous outcomes are handled by platform adjudication policy.',
  defaultPredictionMarketRules: `
  Rules:
  - This market resolves based on the outcome described in the question. Resolution will use publicly available and reliable sources such as official statements, verified data providers, or reputable news organizations. 
  - If the outcome becomes clear before the listed end date, the market may resolve early. If the event cannot be determined or the question becomes ambiguous, the platform may resolve the market using best judgment based on available information.
  - All resolutions are final.`,
  pleaseLogInToFavouriteQuestions: 'Please log in to favourite questions.',
  removeFromFavourites: 'Remove from favourites',
  addToFavourites: 'Add to favourites',
  unableToUpdateFavouriteQuestionPleaseTryAgain: 'Unable to update favourite question. Please try again.',
  marketOrderInProgress: 'Market order in progress',
  noActiveMarketOrder: 'No active market order',
  marketOrderRunning: 'Market order running',
  remainingAmount: 'Remaining: ${{amount}}',
  remainingShares: 'Remaining: {{shares}} shares',
  statusState: 'Status: {{state}}',
  noMarketOrderRunning: 'No market order running. You can find past market orders in the Orders tab on your Portfolio page.',
  deposit: 'Deposit',
  withdraw: 'Withdraw',
  closeWalletActivityModal: 'Close wallet activity modal',
  enterAmountToAction: 'Enter amount to {{action}}',
  depositSuccessful: 'Deposit successful',
  depositFailedPleaseTryAgain: 'Deposit failed. Please Try Again.',
  withdrawalSuccessful: 'Withdrawal successful',
  withdrawFailedPleaseTryAgain: 'Withdraw failed. Please Try Again.',
  mergeSuccessfulBalanceCredited: 'Merge successful. Balance credited.',
  mergeSuccessfulCreditPending: 'Merge successful. Credit pending — balance will update shortly.',
  orderPlacedSuccessfully: 'Order placed successfully',
  placeOrderFailedPleaseTryAgain: 'Place order failed. Please Try Again.',
  orderCancelledSuccessfully: 'Order cancelled successfully',
  cancelLimitOrderFailedPleaseTryAgain: 'Cancel limit order failed. Please Try Again.',
  commentAdded: 'Comment added',
  addCommentFailedPleaseTryAgain: 'Add comment failed. Please Try Again.',
  commentDeleted: 'Comment deleted',
  deleteCommentFailedPleaseTryAgain: 'Delete comment failed. Please Try Again.',
  failedToLoadNotifications: 'Failed to load notifications',
  commentCannotBeEmpty: 'Comment cannot be empty.',
  commentNotFound: 'Comment not found.',
  demoMultiOutcomeMarket: 'Demo multi-outcome market',
  outcomeAlpha: 'Outcome Alpha',
  outcomeBeta: 'Outcome Beta',
  outcomeGamma: 'Outcome Gamma',
  greatMarketToLearnLimitOrders: 'Great market to learn limit orders — try placing a bid below the current price.',
  theOrderbookUpdatesLiveOnceYouStartPlacingDemoOrders: 'The orderbook updates live once you start placing demo orders.',
  demoOutcome: 'Demo outcome',
  demoMarketControls: 'Demo market controls',
  simulateCloseAndSettlementToSeeHowTheMarketBehaves: 'Simulate close and settlement to see how the market behaves.',
  closePanel: 'Close panel',
  closeMarket: 'Close market',
  tradingOpen: 'Trading open',
  stopsTradingClearsTheOrderbookAndClosesOpenOrders: 'Stops trading, clears the orderbook, and closes open orders. Remaining prepaid amounts on bid orders return to your wallet. Positions stay open until settlement.',
  marketClosed: 'Market closed',
  settleMarket: 'Settle market',
  ready: 'Ready',
  awaitingClose: 'Awaiting close',
  pickTheWinningOutcomeDescription: 'Pick the winning outcome. Winning shares pay $1 each, positions are cleared, and options show as settled with the final result.',
  winningOutcome: 'Winning outcome',
  settlementOutcome: 'Settlement outcome',
  closeManageMarketPanel: 'Close manage market panel',
  manageMarket: 'Manage market',
  manageDemoMarket: 'Manage demo market',
  noChartDataYet: 'No chart data yet',
  priceHistoryWillAppearHereAsTradesHappen: 'Price history will appear here as trades happen.',
  chartTimeRange: 'Chart time range',
  allMarkets: 'All Markets',
  backToCollateral: 'Back to collateral · {{marketTitle}}',
  demo: 'Demo',
  depositing: 'Depositing...',
  equalYesAndNoShares: 'Equal Yes & No shares · {{marketTitle}}',
  estValue: 'Est. {{value}}',
  favouriteQuestions: 'Favourite Questions',
  favourites: 'Favourites',
  feePerShareFormula: 'Fee per share (¢) = price × (100 − price) × {{coefficient}} / 10,000',
  limitBuy: 'Limit buy',
  limitSell: 'Limit sell',
  marketBuyOn: 'Market buy on {{marketTitle}}',
  marketSellOn: 'Market sell on {{marketTitle}}',
  marketResolutionPayoutReceived: 'Market resolution payout received. New balance: {{currency}} {{formattedBalance}}',
  marketsPagination: 'Markets pagination',
  noFavouriteQuestionsYet: 'No favourite questions yet.',
  noTitle: 'No title',
  optionNumber: 'Option {{number}}',
  postOnlyLimitBuy: 'Post-only limit buy',
  system: 'SYSTEM',
  unknownOrderType: 'Unknown order type: {{orderType}}',
  withdrawing: 'Withdrawing...',
  yourBalanceWasCredited: 'Your balance was credited. New balance: {{currency}} {{formattedBalance}}',
  yourBalanceWasDebited: 'Your balance was debited. New balance: {{currency}} {{formattedBalance}}',
  thisMarket: 'this market',
  yourPositionText: 'your position',
  amountYesAndNo: '{{amount}} Yes + {{amount}} No',
  daysAgo: '{{days}}d ago',
  hoursAgo: '{{hours}}h ago',
  minutesAgo: '{{minutes}}m ago',
  outcomeSharesAtMarket: '{{outcome}} shares at market',
  sharesYesAndNo: '{{shares}} Yes + {{shares}} No',
  sharesOutcomeAtPrice: '{{shares}} {{outcome}} @ {{price}}¢ · {{marketTitle}}',
  sharesOutcome: '{{shares}} {{outcome}} shares'
}

/**
 * NOTE:
 * =================================================================================================
 * Please go through this spreading objects first before adding new translation key. So that the
 * duplicate translations will not be created and help us to maintain the consitency of code.
 * If you didn't find any of translation as per your requirement in reserve or api success & error
 * msg translation object, Please add new translation with unique key name in otherTranslationKeys
 * Object. Unique key names help us to avoid overriding of translations.
 * =================================================================================================
 */
export default {
  ...reservedTranslationsWithUniqueKeyNames,
  ...apiSuccessMessagesTranslations,
  ...apiErrorMessagesTranslations,
  ...otherTranslationKeys,
  ...predictionMarketTranslations
}
